import type React from "react";
import type { ReactNode, Ref } from "react";
import { styleWithVars } from "@lib/cssVars";
import type { DensityViewport } from "./densityViewport.lib";
import styles from "./DensityChart.module.scss";

interface DensityChartViewportProps {
    viewportRef: Ref<HTMLDivElement>;
    viewport: DensityViewport;
    /** The drawn bars, which the strip lays out from `viewport.endBar`. */
    barCount: number;
    isEasing: boolean;
    onPointerMove: (event: React.PointerEvent<HTMLDivElement>) => void;
    onPointerLeave: () => void;
    children: ReactNode;
}

/** The chart body: a clipped viewport whose strip of drawn bars slides by `viewport.offset`. */
export function DensityChartViewport({
    viewportRef,
    viewport,
    barCount,
    isEasing,
    onPointerMove,
    onPointerLeave,
    children,
}: DensityChartViewportProps) {
    return (
        <div
            className={styles.body}
            onPointerMove={onPointerMove}
            onPointerLeave={onPointerLeave}
        >
            <div ref={viewportRef} className={styles.viewport}>
                <div
                    className={styles.world}
                    data-easing={isEasing}
                    style={styleWithVars({ "--offset": viewport.offset })}
                >
                    <div
                        className={styles.strip}
                        style={styleWithVars({
                            "--strip-start": viewport.endBar,
                            "--strip-bars": barCount,
                        })}
                    >
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}
